import { createSlice } from "@reduxjs/toolkit";
import eventBus from "../../utils/eventBus";

export const modalSlice = createSlice({
  name: "modals",
  initialState: {
    cart: false,
    menu: false,
    menuFilter: false,
    search: false,
    cookies: false,
    teamMember: {
      name: "Jean-Louis",
      open: false,
    },
  },
  reducers: {
    setModal: (state, action) => {
      switch (action.payload) {
        case "cart":
          state.cart = !state.cart;
          break;
        case "menu":
          state.menu = !state.menu;
          break;
        case "menuFilter":
          state.menuFilter = !state.menuFilter;
          break;
        case "search":
          state.search = !state.search;
          break;
        case "cookies":
          state.cookies = !state.cookies;
          break;
        default:
          break;
      }
    },
    setCart: (state, action) => {
      state.cart = action.payload;
    },
    setMenu: (state, action) => {
      state.menu = action.payload;
    },
    setMenuFilter: (state, action) => {
      state.menuFilter = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
    },
    setCookies: (state, action) => {
      state.cookies = action.payload;
    },
    setTeamMember: (state, action) => {
      state.teamMember = action.payload;
    },
  },
});

export const {
  setModal,
  setCart,
  setMenu,
  setMenuFilter,
  setSearch,
  setCookies,
  setTeamMember,
} = modalSlice.actions;

export default modalSlice.reducer;
